<sim-base-chip-input
	[formState]="scenarioGroupFc"
	[label]="label"
	[placeholder]="placeholder"
	[autoCompleteValues]="autoCompleteData"
	[isMultiSelect]="canSelectMultipleScenarioGroups"
	[canAddNewItem]="true"
	(searchFieldChanged)="reloadAutoCompleteData($event)"
	(optionSelected)="optionSelected.emit($event)"
	(createNewItemClicked)="openCreateScenarioGroupDialog()"
>
	<ng-container labelSuffix>
		<ng-content select="[labelSuffix]" />
	</ng-container>
</sim-base-chip-input>
